import React from 'react';
import {
  bool, func, string, arrayOf, exact, number, objectOf,
} from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import {
  Flex, Typography, Input, Checkbox,
} from '@atoms';
import { SpecialSizesModal } from '@molecules';
import {
  DraggableItems, SpecialProcessModal, AvailabilityProcessModal, EntitySpecials,
} from '@organisms';
import { Edit } from '@templates';

const SubcategoryProcess = ({
  onEditConfirm,
  onSpecialWarningModalClose,
  isSpecialWarningModalOpen,
  onSpecialAvailabilityAdd,
  onSpecialAvailabilityDetach,
  specialAvailabilities,
  isSpecialConfirmButtonDisabled,
  onSpecialDelete,
  isSpecialDeleteModalOpen,
  onSpecialDeleteModalChangeState,
  onSpecialEditSubmit,
  onSpecialAdd,
  onSpecialEdit,
  isSizesSpecialModalOpen,
  onSizesSpecialModalChangeState,
  onSelectedSizeSpecialChange,
  selectedSizeSpecial,
  subcategorySizes,
  isEditingSpecial,
  discountTypes,
  selectedDiscountType,
  onDiscountTypeChange,
  isSpecialModalOpen,
  onSpecialModalChangeState,
  subcategorySpecials,
  onStartDateRemove,
  onEndDateRemove,
  onStartTimeRemove,
  onEndTimeRemove,
  onAvailabilityEdit,
  isAvailabilityConfirmButtonDisabled,
  onAvailabilityModalChangeState,
  isAvailabilityModalOpen,
  onAvailabilityDelete,
  onAvailabilityDeleteModalChangeState,
  onAvailabilityEditSubmit,
  isAvailabilityDeleteModalOpen,
  isAvailabilityEditing,
  startTime,
  endTime,
  startDate,
  endDate,
  onStartTimeChange,
  onEndTimeChange,
  onStartDateChange,
  onEndDateChange,
  onDayClick,
  selectedWeekDays,
  onAvailabilityNameChange,
  availabilityName,
  onAvailabilityDetach,
  onAvailabilityAdd,
  availabilities,
  error,
  isSubcategoryActive,
  onSubcategoryActivityChange,
  isModalOpen,
  onModalChangeState,
  isConfirmButtonDisabled,
  isEditing,
  onSubcategoryDelete,
  items,
  isLoading,
  subcategoryName,
  onToastClose,
  onSubcategoryNameChange,
  onEditSubmit,
  onEditCancel,
  hasServerError,
  onDragEnd,
}) => (
  <>
    <Edit
      error={error}
      name={subcategoryName}
      isModalOpen={isModalOpen}
      isEditing={isEditing}
      onModalChangeState={onModalChangeState}
      onDelete={onSubcategoryDelete}
      isConfirmButtonDisabled={isConfirmButtonDisabled}
      isLoading={isLoading}
      onToastClose={onToastClose}
      onEditCancel={onEditCancel}
      onEditSubmit={onEditSubmit}
      hasServerError={hasServerError}
    >
      <Input
        marginTop="xl2"
        type="text"
        id="subcategoryName"
        name="subcategoryName"
        placeholder="Subcategory name"
        value={subcategoryName}
        onChange={onSubcategoryNameChange}
        data-cy="subcategoryName"
      />
      <Flex itemsCenter selfCenter marginTop="xl5">
        <Checkbox onCheckedStateChange={onSubcategoryActivityChange} isChecked={isSubcategoryActive} />
        <Typography marginLeft="lg" size="xl3" weight="black">Is subcategory active?</Typography>
      </Flex>
      <Flex itemsCenter column paddingTop="xl5">
        <Typography marginBottom="md" size="xl3" weight="black">
          Items of current subcategory
        </Typography>
        {items.length
          ? (
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="subcategoryItems">
                {provided => (
                  <Flex column ref={provided.innerRef} {...provided.droppableProps}>
                    <DraggableItems items={items} />
                    {provided.placeholder}
                  </Flex>
                )}
              </Droppable>
            </DragDropContext>
          )
          : (
            <Flex justifyStart>
              <Typography size="lg" color="warmGrey" weight="black" marginBottom="lg">
                Nothing here yet
              </Typography>
            </Flex>
          )}
        <SpecialProcessModal
          onEditConfirm={onEditConfirm}
          onSpecialWarningModalClose={onSpecialWarningModalClose}
          isSpecialWarningModalOpen={isSpecialWarningModalOpen}
          onAvailabilityModalChangeState={onAvailabilityModalChangeState}
          onAvailabilityDetach={onSpecialAvailabilityDetach}
          availabilities={specialAvailabilities}
          onAvailabilityEdit={onAvailabilityEdit}
          onAvailabilityAdd={onSpecialAvailabilityAdd}
          onStartDateRemove={onStartDateRemove}
          onEndDateRemove={onEndDateRemove}
          onStartTimeRemove={onStartTimeRemove}
          onEndTimeRemove={onEndTimeRemove}
          isAvailabilityConfirmButtonDisabled={isAvailabilityConfirmButtonDisabled}
          onAvailabilityDeleteModalChangeState={onAvailabilityDeleteModalChangeState}
          startTime={startTime}
          endTime={endTime}
          startDate={startDate}
          endDate={endDate}
          onStartTimeChange={onStartTimeChange}
          onEndTimeChange={onEndTimeChange}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
          onAvailabilityNameChange={onAvailabilityNameChange}
          onAvailabilityEditSubmit={onAvailabilityEditSubmit}
          availabilityName={availabilityName}
          isAvailabilityModalOpen={isAvailabilityModalOpen}
          onAvailabilityModalClose={onAvailabilityModalChangeState}
          isAvailabilityDeleteModalOpen={isAvailabilityDeleteModalOpen}
          onAvailabilityDelete={onAvailabilityDelete}
          onDayClick={onDayClick}
          selectedWeekDays={selectedWeekDays}
          isConfirmButtonDisabled={isSpecialConfirmButtonDisabled}
          onSpecialEditSubmit={onSpecialEditSubmit}
          onSelectedEntityChange={onSelectedSizeSpecialChange}
          entities={subcategorySizes}
          selectedEntity={selectedSizeSpecial}
          isEditing={isEditingSpecial}
          discountTypes={discountTypes}
          onSpecialDelete={onSpecialDelete}
          isSpecialDeleteModalOpen={isSpecialDeleteModalOpen}
          onSpecialDeleteModalChangeState={onSpecialDeleteModalChangeState}
          selectedDiscountType={selectedDiscountType}
          onDiscountTypeChange={onDiscountTypeChange}
          isModalOpen={isSpecialModalOpen}
          onModalClose={onSpecialModalChangeState}
        />
        <SpecialSizesModal
          onSizeSelect={onSelectedSizeSpecialChange}
          onModalClose={onSizesSpecialModalChangeState}
          isModalOpen={isSizesSpecialModalOpen}
          sizes={subcategorySizes}
        />
        {isEditing && (
          <>
            <Typography marginBottom="md" marginTop="xl5" size="xl3" weight="black">
              Availability periods of subcategory
            </Typography>
            <DragDropContext>
              <Droppable droppableId="subcategoryAvailabilities">
                {provided => (
                  <Flex column ref={provided.innerRef} {...provided.droppableProps}>
                    <DraggableItems
                      onItemClick={onAvailabilityEdit}
                      onItemRemove={onAvailabilityDetach}
                      onItemAdd={onAvailabilityAdd}
                      isDraggable={false}
                      canBeAdded={isEditing}
                      items={availabilities}
                    />
                    {provided.placeholder}
                  </Flex>
                )}
              </Droppable>
            </DragDropContext>
            <EntitySpecials
              onSpecialEdit={onSpecialEdit}
              onSpecialAdd={onSpecialAdd}
              specials={subcategorySpecials}
            />
          </>
        )}
      </Flex>
      <AvailabilityProcessModal
        onStartDateRemove={onStartDateRemove}
        onEndDateRemove={onEndDateRemove}
        onStartTimeRemove={onStartTimeRemove}
        onEndTimeRemove={onEndTimeRemove}
        isConfirmButtonDisabled={isAvailabilityConfirmButtonDisabled}
        onAvailabilityDeleteModalChangeState={onAvailabilityDeleteModalChangeState}
        startTime={startTime}
        endTime={endTime}
        startDate={startDate}
        endDate={endDate}
        onStartTimeChange={onStartTimeChange}
        onEndTimeChange={onEndTimeChange}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        onAvailabilityNameChange={onAvailabilityNameChange}
        isEditing={isAvailabilityEditing}
        onAvailabilityEditSubmit={onAvailabilityEditSubmit}
        availabilityName={availabilityName}
        isModalOpen={isAvailabilityModalOpen}
        onModalClose={onAvailabilityModalChangeState}
        isAvailabilityDeleteModalOpen={isAvailabilityDeleteModalOpen}
        onAvailabilityDelete={onAvailabilityDelete}
        onDayClick={onDayClick}
        selectedWeekDays={selectedWeekDays}
      />
    </Edit>
  </>
);

SubcategoryProcess.defaultProps = {
  selectedSizeSpecial: null,
  subcategorySpecials: [],
};

SubcategoryProcess.propTypes = {
  onEditConfirm: func.isRequired,
  onSpecialWarningModalClose: func.isRequired,
  isSpecialWarningModalOpen: bool.isRequired,
  onSpecialAvailabilityAdd: func.isRequired,
  specialAvailabilities: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  onSpecialAvailabilityDetach: func.isRequired,
  isSpecialConfirmButtonDisabled: bool.isRequired,
  onSpecialDelete: func.isRequired,
  isSpecialDeleteModalOpen: bool.isRequired,
  onSpecialDeleteModalChangeState: func.isRequired,
  onSpecialEditSubmit: func.isRequired,
  onSpecialAdd: func.isRequired,
  isSizesSpecialModalOpen: bool.isRequired,
  onSizesSpecialModalChangeState: func.isRequired,
  onSelectedSizeSpecialChange: func.isRequired,
  selectedSizeSpecial: number,
  subcategorySizes: arrayOf(exact({
    id: number,
    name: string,
    price: number,
  })).isRequired,
  onSpecialEdit: func.isRequired,
  isEditingSpecial: bool.isRequired,
  discountTypes: objectOf(exact({
    name: string,
    inputValue: string,
    inputHandler: func,
  })).isRequired,
  selectedDiscountType: string.isRequired,
  onDiscountTypeChange: func.isRequired,
  isSpecialModalOpen: bool.isRequired,
  onSpecialModalChangeState: func.isRequired,
  subcategorySpecials: arrayOf(exact({
    id: number,
    categoryId: number,
    available: bool,
    availabilityIds: arrayOf(number),
    sizeName: string,
    discountType: string,
    discountValue: number,
  })),
  onStartDateRemove: func.isRequired,
  onEndDateRemove: func.isRequired,
  onStartTimeRemove: func.isRequired,
  onEndTimeRemove: func.isRequired,
  onAvailabilityEdit: func.isRequired,
  isAvailabilityConfirmButtonDisabled: bool.isRequired,
  onAvailabilityModalChangeState: func.isRequired,
  isAvailabilityModalOpen: bool.isRequired,
  onAvailabilityDelete: func.isRequired,
  onAvailabilityDeleteModalChangeState: func.isRequired,
  onAvailabilityEditSubmit: func.isRequired,
  isAvailabilityDeleteModalOpen: bool.isRequired,
  isAvailabilityEditing: bool.isRequired,
  startTime: string.isRequired,
  endTime: string.isRequired,
  startDate: string.isRequired,
  endDate: string.isRequired,
  onStartTimeChange: func.isRequired,
  onEndTimeChange: func.isRequired,
  onStartDateChange: func.isRequired,
  onEndDateChange: func.isRequired,
  onDayClick: func.isRequired,
  selectedWeekDays: arrayOf(number).isRequired,
  onAvailabilityNameChange: func.isRequired,
  availabilityName: string.isRequired,
  onAvailabilityDetach: func.isRequired,
  onAvailabilityAdd: func.isRequired,
  availabilities: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  error: string.isRequired,
  isSubcategoryActive: bool.isRequired,
  onSubcategoryActivityChange: func.isRequired,
  isModalOpen: bool.isRequired,
  onModalChangeState: func.isRequired,
  isConfirmButtonDisabled: bool.isRequired,
  isEditing: bool.isRequired,
  onSubcategoryDelete: func.isRequired,
  items: arrayOf(exact({
    name: string,
    id: number,
  })).isRequired,
  onDragEnd: func.isRequired,
  onToastClose: func.isRequired,
  hasServerError: bool.isRequired,
  isLoading: bool.isRequired,
  subcategoryName: string.isRequired,
  onSubcategoryNameChange: func.isRequired,
  onEditSubmit: func.isRequired,
  onEditCancel: func.isRequired,
};

export default SubcategoryProcess;
